<template lang="">
  <div>
    <div class="py-2">
      <div class="row mx-2 py-4 px-3 bg-white rounded">
        <div class="col-12 mb-3">
          <em class="fas fa-history text-orange mr-2" />
          <span class="font-weight-bold">Historial de Enmiendas</span>
        </div>
        <div class="col-12">
          <custom-result-not-found v-if="history.length === 0" />
          <div v-for="(item, idx) in history" :key="idx">
            <timeline-item :key="idx" :date="item.date">
              <div class="row">
                <div class="col-12 col-lg-6 font-weight-bold">
                  Enmienda {{ padleft(history.length - idx, 2) }}
                </div>
                <div class="col-12 col-lg-6">
                  <div class="color-secondary-6 font-14">
                    Añadido Por:
                  </div>
                  <div class="font-weight-normal color-black font-16">
                    {{ item?.createdBy | empty }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="color-secondary-6 font-14">
                    Comentario:
                  </div>
                  <div class="font-weight-normal color-black font-16">
                    {{ item?.comment | empty }}
                  </div>
                </div>
              </div>
            </timeline-item>
          </div>
          <div class="row my-4">
            <div class="col text-center">
              <action-button
                v-if="showMore"
                i="fas fa-chevron-down"
                variant="outline-success custom-view-more actionButton"
                @click="handlerMore"
              >
                Ver más
              </action-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TimelineItem from '@quisit/timeline-item';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';

export default {
  name: 'AmendmentHistory',
  components: {
    TimelineItem,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    history: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showMore() {
      return this.history.length > this.logCount && this.history.length > 5;
    },
  },
  methods: {
    handlerMore() {
      this.logCount += 5;
    },
    padleft(value, length) {
      return value.toString().padStart(length, '0');
    },
  },
};
</script>
<style lang=""></style>
